import * as types from 'models/actionTypes'
import { openComposition } from 'models/compositions/actions'

export const compositionsToggle = () => ({
    type: types.COMPOSITIONS_TOGGLE,
})

export const scenesToggle = () => ({
    type: types.SCENES_TOGGLE,
})

export const scenesOpen = () => ({
    type: types.SCENES_OPEN,
})

export const artToggle = () => ({
    type: types.ART_TOGGLE,
})

export const filterArtTray = (filter) => ({
    type: types.ART_TRAY_FILTER,
    filter,
})

export const openDesignSidepanel = (renderItemId, trackingInfo = {}) => ({
    type: types.OPEN_DESIGN_SIDEPANEL,
    renderItemId,
    trackingInfo,
})

export const setDesignSidepanelMode = (mode, trackingInfo = {}) => ({
    type: types.SET_DESIGN_SIDEPANEL_MODE,
    mode,
    trackingInfo,
})

export const closeDesignSidepanel = () => ({
    type: types.CLOSE_DESIGN_SIDEPANEL,
})

export const presentItemSelection = (shouldPresent) => ({
    type: types.PRESENT_ITEM_SELECTION,
    shouldPresent,
})

export const displayItemSelection = (display) => ({
    type: types.ITEM_SELECTION_DISPLAY,
    display,
})

export const closeWelcomePopup = () => ({
    type: types.CLOSE_WELCOME_POPUP,
})

export const selectSceneSelectionTab = (shouldShowStock) => ({
    type: types.SELECT_SCENE_SELECTION_TAB,
    shouldShowStock,
})

export const viewStockScenes = () => (dispatch) => {
    dispatch(scenesOpen())
    dispatch(selectSceneSelectionTab(true))
    dispatch(openComposition(-1))
}

export const reloadPage = () => ({
    type: types.RELOAD_PAGE,
})

export const toggleSharePanelOpen = () => ({
    type: types.SHARE_PANEL_OPEN_TOGGLE,
})

export const setIsMagicWindowLoading = (isMagicWindowLoading) => ({
    type: types.SET_MAGIC_WINDOW_LOADING,
    isMagicWindowLoading,
})

export const setShowFilterModal = (isOpen) => ({
    type: types.SET_FILTER_MODAL_OPEN,
    isOpen,
})

// Shows or hides the swap menu
// showSwap: bool
// furnitureId: sets the swapAnchorId in the furniture reducer for which swapabble items are shown
export const showSwapMenuForId = (showSwap, furnitureId = -1) => ({
    type: types.SHOW_SWAP_MENU,
    showSwapMenu: showSwap,
    id: furnitureId,
})

export const showMissingWallsModal = (show = true) => ({
    type: types.SHOW_MISSING_WALLS_MODAL,
    showMissingWallsModal: show,
})

export const openDesignLab = () => ({
    type: types.OPEN_DESIGN_LAB,
})

export const setMobileOrientation = (orientation) => ({
    type: types.SET_MOBILE_ORIENTATION,
    orientation,
})

export const showLoginPromptModal = (show = true) => ({
    type: types.SHOW_LOGIN_PROMPT_MODAL,
    showLoginPromptModal: show,
})

export const showDesignSummary = (show = true) => ({
    type: types.SHOW_DESIGN_SUMMARY,
    showDesignSummary: show,
})
